import { COURSE_TYPES } from 'constants/common';

export const modifyPreviewForTableRender = (data: any) =>
  data.map((content: any) => {
    if (content.type !== COURSE_TYPES.COURSE) {
      return { ...content, preview: content.resultPreview };
    }

    return content;
  });
